import { isUnknownAuthState, useAuthStore } from "@roman/shared/store/auth.store";
import { Navigate, Outlet, useLocation } from "react-router-dom";

type ProtectedRouteProps = {
  redirectPath?: string;
};

export const ProtectedRoute = ({ redirectPath = "/login" }: ProtectedRouteProps) => {
  const location = useLocation();
  const authState = useAuthStore((state) => state.authState);

  if (isUnknownAuthState(authState)) {
    return null;
  }

  return authState === "authenticated" ? (
    <Outlet />
  ) : (
    <Navigate to={redirectPath} state={{ from: location.pathname }} replace />
  );
};
